module.exports = __webpack_public_path__ + "media/images/lb/162-b873e8b6919157d2c5927069c5d9b542.svg";